module.exports = __webpack_public_path__ + "static/media/mouthLeft.2c741789.obj";